import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareProformaIssueFormsDirectRoute: InvariantJiraRoute = {
	name: 'software-proforma-issue-forms-direct',
	path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
	exact: true,
};
